export default "__VITE_ASSET__CK31A_NX__"